module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "clound"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("会员积分")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('a', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    attrs: {
      "href": _vm.linkUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.getUrl
    }
  }, [_c('span', [_vm._v("立即使用")])]), _vm._v(" "), _c('a', {
    staticClass: "cancel",
    attrs: {
      "href": "http://qmm.la/xVk0Fx",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会员积分三大优势")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("./img/clound1.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "plain"
  }, [_vm._v("到店消费领积分，有效增加回头客")])])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("./img/clound2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "plain"
  }, [_vm._v("积分兑换店内商品，最少成本做营销")])])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("./img/clound3.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "plain"
  }, [_vm._v("线上积分商城，实现个性化积分兑换")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-8d744856"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/memberIntegral/memberIntegral.vue
// module id = 843
// module chunks = 0